import Icon from '../components/Icon.vue'

Icon.register({
  'laugh-squint': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM281.8 169.7c-7.7 4.7-7.7 15.9 0 20.6l80 48c11.5 6.8 24.1-7.6 15.4-18l-33.6-40.3 33.6-40.3c8.6-10.3-3.8-24.9-15.4-18zM118.8 139.7l33.6 40.3-33.6 40.3c-8.6 10.4 3.9 24.8 15.4 18l80-48c7.8-4.7 7.8-15.9 0-20.6l-80-48c-11.6-6.9-24 7.7-15.4 18zM398.9 306c1.2-9.6-6.3-18-15.9-18h-270c-9.6 0-17.1 8.5-15.9 18 8.9 71 69.5 126 142.9 126h16c73.4 0 134-55 142.9-126z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/laugh-squint.js
// module id = 1511
// module chunks = 0